import { render, staticRenderFns } from "./AddDevice.vue?vue&type=template&id=10204416&scoped=true&"
import script from "./AddDevice.vue?vue&type=script&lang=js&"
export * from "./AddDevice.vue?vue&type=script&lang=js&"
import style0 from "./AddDevice.vue?vue&type=style&index=0&id=10204416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10204416",
  null
  
)

export default component.exports